import { render, staticRenderFns } from "./GapRates.vue?vue&type=template&id=b5bf68f0&scoped=true"
import script from "./GapRates.vue?vue&type=script&lang=js"
export * from "./GapRates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5bf68f0",
  null
  
)

export default component.exports